export type TablePagination = {
  page_size: number;
  page_index: number;
  remaining_pages: number;
  total_pages: number;
  total_records: number;
};

export enum SortOrder {
  asc = "ASCENDING",
  desc = "DESCENDING",
}

export type TableSort = {
  sort_by: string;
  sorting_direction: SortOrder | null;
};
